import { atom } from 'recoil';

export const scoreValue = atom({
    key: "ScoreValue",
    default: 23
});